import { render, staticRenderFns } from "./FcErrorForm.vue?vue&type=template&id=5b6aaef4&scoped=true&"
import script from "./FcErrorForm.vue?vue&type=script&lang=js&"
export * from "./FcErrorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6aaef4",
  null
  
)

export default component.exports